import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyFeedInformation, setDairyFeedInformationAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_FEED_INFORMATION } from "consts";

import { UploadableFeedInformation } from "models";

export const useMutateFootprintingDairyFeedInformation = (farmId: string, year: number, payload: UploadableFeedInformation[], primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_FEED_INFORMATION, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setDairyFeedInformationAdmin(primaryDataId, payload) : setDairyFeedInformation(primaryDataId, payload)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_FEED_INFORMATION, primaryDataId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
